import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Phone, ArrowRight } from "lucide-react";
import { endpoints } from "@/lib/api";

const Journalist = ({ j }) => (
  <div data-testid={`about-journalist-${j.id}`} className="text-center group">
    <div className="aspect-square rounded-2xl overflow-hidden bg-[#121620] border border-[#273042] mb-2">
      <img src={j.photo || "/bb-logo.png"} alt={j.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={(e) => { e.currentTarget.src = "/bb-logo.png"; }} />
    </div>
    <div className="text-white font-semibold text-sm truncate">{j.name}</div>
    {j.role && <div className="text-xs text-[#E11D2A] truncate">{j.role}</div>}
  </div>
);

export default function About() {
  const [team, setTeam] = useState([]);
  const [h, setH] = useState({});
  useEffect(() => {
    endpoints.journalists().then((r) => setTeam(r.data || [])).catch(() => {});
    endpoints.settings().then((r) => setH(r.data?.home || {})).catch(() => {});
  }, []);
  return (
    <div className="px-3 sm:px-6 lg:px-8 max-w-6xl mx-auto py-8 sm:py-12 pb-28" data-testid="about-page">
      <section className="grid lg:grid-cols-2 gap-6 lg:gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#E11D2A]/15 border border-[#E11D2A]/30 text-[#EF4444] text-[11px] font-bold uppercase tracking-wider">
            <Trophy className="w-3.5 h-3.5" /> {h.whoTitle || "Who we are"}</div>
          <h1 className="mt-3 text-3xl sm:text-5xl font-extrabold tracking-tight text-white">B&B KIGALI FM 89.7</h1>
          <p className="text-slate-300 mt-3 text-sm sm:text-base leading-relaxed" data-testid="about-text">
            {h.whoText || "We are a news and radio platform bringing you the latest in sports, news, music and culture from Rwanda and around the world. Through live radio, news updates, interviews, original stories, sports analysis and on-demand shows, we keep our audience informed, entertained and connected wherever they are."}
          </p>
          <Link to="/contact" data-testid="about-contact-btn" className="mt-5 inline-flex items-center gap-2 h-11 px-5 rounded-full bg-[#E11D2A] hover:bg-[#C8121F] text-white font-bold transition-colors">
            <Phone className="w-4 h-4" /> Contact us</Link>
        </div>
        <div className="relative rounded-2xl overflow-hidden border border-[#273042]">
          <img src={h.whoImage || "/img/who.jpg"} alt="B&B KIGALI crew" loading="lazy" className="w-full aspect-[4/3] object-cover"
            onError={(e) => { if (!e.currentTarget.src.endsWith("/img/who.jpg")) e.currentTarget.src = "/img/who.jpg"; }} />
          <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/90 to-transparent text-white text-lg font-bold">{h.whoQuote || "MURI SIPORO, NI IGITEGO!"}</div>
        </div>
      </section>

      {team.length > 0 && (
        <section className="mt-10 sm:mt-14" data-testid="about-journalists">
          <h2 className="text-xl sm:text-2xl font-bold text-white">{h.journalistsTitle || "Our Journalists"}</h2>
          <p className="text-slate-400 text-sm mt-1 mb-4">{h.journalistsSubtitle || "The voices that bring you every goal, every story."}</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">{team.map((j) => <Journalist key={j.id} j={j} />)}</div>
        </section>
      )}

      <Link to="/contact" data-testid="about-contact-strip" className="mt-10 flex items-center gap-3 rounded-2xl border border-[#273042] bg-[#121620] p-4 hover:border-[#E11D2A] transition-colors">
        <Phone className="w-6 h-6 text-[#E11D2A] shrink-0" />
        <span className="flex-1 text-white font-semibold text-sm sm:text-base">Questions, adverts or partnerships? Talk to us.</span>
        <ArrowRight className="w-5 h-5 text-slate-400" />
      </Link>
    </div>
  );
}
